import { atom } from 'recoil';

const childThemeState = atom({
    key: 'childTheme',
    default: '',
});

export {
    childThemeState
};